import { TypographyProps, theme } from '@aloft/toolkit-sui';

export const fieldTypographyProps: TypographyProps = {
  variant: 'body1',
  color: 'textPrimary',
  __dangerDoNotUseSx: {
    width: '100%',
    height: '32px',
    backgroundColor: theme.colors.textOffset,
    padding: '4px 8px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textWrap: 'nowrap',
    whiteSpace: 'nowrap',
  },
};

export const readOnlyFieldTypographyProps: TypographyProps = {
  ...fieldTypographyProps,
  __dangerDoNotUseSx: {
    ...fieldTypographyProps.__dangerDoNotUseSx,
    backgroundColor: theme.colors.surface2,
  },
};

export const editableFieldOutlineSx = {
  outline: '0',
  _focusVisible: {
    outline: '1.5px solid',
    outlineOffset: '-1.5px',
    outlineColor: '#3355db',
  },
};
